import { Alert, Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { ERROR_SNACKBAR, SUCCESS_SNACKBAR } from "../../../consts";
import { useCRUD } from "../../../api/crud";
import { PERMISSION_GROUPS_URL } from "../../../api/permissions";
import { PermissionGroup } from "../../../types/permissions";
import styles from "./removePermissionGroup.module.css";

interface RemovePermissionGroupProps {
  group?: PermissionGroup;
  onSuccess?: () => void;
}

export const RemovePermissionGroup = ({ group, onSuccess }: RemovePermissionGroupProps) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { remove } = useCRUD(PERMISSION_GROUPS_URL);

  const handleDelete = async () => {
    if (!group?.id) return;

    const result = await remove({id: group.id});

    if (result?.success) {
      window.dispatchEvent(new Event("permissionGroupsUpdated"));
      enqueueSnackbar(t("Permission group deleted successfully"), SUCCESS_SNACKBAR);
      onSuccess?.();
    } else {
      enqueueSnackbar(t("Permission group deletion failed"), ERROR_SNACKBAR);
    }
  };

  return (
    <Box className={styles.container}>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {t("Are you sure you want to delete the permission group")} <strong>{group?.name}</strong>?
      </Typography>
      <Alert severity="warning">
        <Typography variant="body2">
          {t('This action cannot be undone. The group will need to be re-created to regain access.')}
        </Typography>
      </Alert>
      <Button
        variant="contained"
        color="error"
        onClick={handleDelete}
        fullWidth
      >
        {t("Delete")}
      </Button>
    </Box>
  );
};
